module.exports = __webpack_public_path__ + "media/images/builder/coverimage-bcc88ea081136cab18ccfdbff761fa50.png";